import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo,
  ERPZertus
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import DropShutdownsPage from "src/pages/Customer/DropShutdowns/DropShutdownsPage";
import CreateEditDropShutdownPage from "src/pages/Customer/DropShutdowns/CreateEditDropShutdownPage";
import CreateSupportTicketPage from "src/pages/Customer/Support/CreateSupportTicketPage";
import ViewSupportTicketPage from "src/pages/Customer/Support/ViewSupportTicketPage";

import CreateDropPage from "./CreateDropPage";
import DropContactDetails from "./DropContactDetails";
import DropOrderSettingsPage from "./DropOrderSettingsPage";
import DropListsPage from "./DropListsPage";
import DropOrdersPage from "./DropOrdersPage";
import DropPriceList from "./DropPriceList";
import DropLeadTimesPage from "./DropLeadTimesPage";
import DropCreditRequestSettingsPage from "./DropCreditRequestSettingsPage";
import DropUsersPage from "./DropUsersPage";
import ViewDropSupportPageAdmin from "./DropSupportPage";

const AdminEditDrop: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/orders",
    pageComponent: DropOrdersPage,
    title: "%ORDERS%",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/lists",
    pageComponent: DropListsPage,
    title: "%LISTS%",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/support/tickets",
    pageComponent: ViewDropSupportPageAdmin,
    title: "Support tickets",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPZertus
    ],
    roles: [ "admin" ],
    modules: [ "support" ],
    canView: ({ global }) => !!global.settings?.supportSettings?.supportTickets.enabled
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/contact-details",
    pageComponent: DropContactDetails,
    title: "Contact Details",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/price-lists",
    pageComponent: DropPriceList,
    title: "Price List",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/defaults",
    pageComponent: DropOrderSettingsPage,
    title: "Order settings",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/lead-times",
    title: "Lead Times",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [],
    roles: [ "admin" ],
    pageComponent: DropLeadTimesPage,
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/credit-request-settings",
    pageComponent: DropCreditRequestSettingsPage,
    title: "Credit request settings",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    modules: [ "credit-request" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/users",
    pageComponent: DropUsersPage,
    title: "%USERS%",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/shutdowns",
    pageComponent: DropShutdownsPage,
    title: "Holidays",
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ],
    privateRoute: true,
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/shutdowns/new",
    title: "Save Holiday",
    pageComponent: CreateEditDropShutdownPage,
    privateRoute: true,
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    hidden: true,
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/shutdowns/:shutdownId",
    title: "Save Holiday",
    pageComponent: CreateEditDropShutdownPage,
    privateRoute: true,
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    menuType: "ADMIN_EDIT_DROP",
    context: "CREATE_EDIT_DROP",
    hidden: true,
    allowedContexts: [ "CREATE_EDIT_DROP", "CREATE_EDIT_CUSTOMER" ]
  }
];

const AdminCreateDrop: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/create",
    pageComponent: CreateDropPage,
    title: "Details",
    menuType: "ADMIN_CREATE_DROP",
    privateRoute: true,
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ]
  },
  {
    exact: true,
    title: "%ORDERS%",
    menuType: "ADMIN_CREATE_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "%LISTS%",
    menuType: "ADMIN_CREATE_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "Order settings",
    menuType: "ADMIN_CREATE_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "Contact Details",
    menuType: "ADMIN_CREATE_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "%USERS%",
    menuType: "ADMIN_CREATE_DROP",
    context: "CREATE_EDIT_DROP",
    permissions: [ "create-branch" ],
    disabled: true,
    privateRoute: true
  }
];

const AdminEditDropNestedRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/support/tickets/raise-ticket",
    pageComponent: CreateSupportTicketPage,
    title: "Support",
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminEditDrop.find(route => route.path === "/admin/customers/:customerId/drops/:dropId/support/tickets") ?? AdminEditDrop[ 0 ],
    hidden: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPZertus
    ],
    roles: [ "admin" ],
    allowedContexts: [ "CREATE_EDIT_DROP" ],
    modules: [ "support" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/drops/:dropId/support/tickets/:supportTicketId",
    pageComponent: ViewSupportTicketPage,
    title: "Support ticket",
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminEditDrop.find(route => route.path === "/admin/customers/:customerId/drops/:dropId/support/tickets") ?? AdminEditDrop[ 0 ],
    roles: [ "admin" ],
    allowedContexts: [ "CREATE_EDIT_DROP" ],
    modules: [ "support" ],
    hidden: true
  }
];

export default [
  ...AdminEditDrop,
  ...AdminCreateDrop,
  ...AdminEditDropNestedRoutes
];
